import { useSelector } from "react-redux";

import { RedirectState } from "../../redux/slices/redirect/redirectSlice";
import { RootState } from "../../redux/store";

const useRedirectState = (): RedirectState => {
    const redirectState = useSelector((state: RootState) => state.redirect);

    return redirectState;
};

export default useRedirectState;
